import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const SeeIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M20.0556 29.3013C15.2003 29.3013 11.2432 25.3535 11.2432 20.4889C11.2432 15.6243 15.191 11.6765 20.0556 11.6765C24.9202 11.6765 28.868 15.6243 28.868 20.4889C28.868 25.3535 24.9202 29.3013 20.0556 29.3013ZM20.0556 13.5475C16.2294 13.5475 13.1142 16.6627 13.1142 20.4889C13.1142 24.3151 16.2294 27.4303 20.0556 27.4303C23.8818 27.4303 26.997 24.3151 26.997 20.4889C26.997 16.6627 23.8818 13.5475 20.0556 13.5475Z"
                fill="currentColor"
            />
            <path
                d="M19.8597 32.3043C9.39143 32.3043 1.49581 21.1812 1.16839 20.7041C1.04678 20.5357 1 20.3392 1 20.1521C1 19.9557 1.05613 19.7592 1.17774 19.5908C1.51452 19.1137 9.57853 8 20.1403 8C31.8154 8 38.5884 19.1792 38.869 19.6563C38.9532 19.7967 39 19.965 39 20.1334C39 20.3018 38.9532 20.517 38.8597 20.6667C38.5603 21.1438 31.4412 32.3043 19.8597 32.3043ZM3.09552 20.1615C4.77006 22.3225 11.5899 30.4333 19.8597 30.4333C29.1211 30.4333 35.5012 22.2102 36.9606 20.1428C35.5667 18.066 29.4485 9.871 20.1403 9.871C11.7582 9.871 4.79813 18.0005 3.09552 20.1615Z"
                fill="currentColor"
            />
        </Icon>
    )
}

SeeIcon.propTypes = {
    secondaryColor: PropTypes.string,
}

export default SeeIcon
